export default __webpack_public_path__ + "static/media/female_icon.c220f752.png";